
const HomeLayout = ({ children }) => {
  return (
    <>
      <div>
        <div className="d-flex flex-column flex-shrink  justify-content-between min-vh-100">
          <div className="">
            {children}
          </div>
        </div>
      </div>
    </>
  )
}
export default HomeLayout
